import { apiGet } from "../baseApi";
import { setDistrictData } from "service/mapper";

export const getById = async (id, cancelToken = null) => {
  try {
    const response = await apiGet("_district", {}, id, { cancelToken });
    return { ...response, data: setDistrictData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
